export class ControlledPromise<T = void> {

    private readonly _promise: Promise<T>;
    private _resolve;
    private _reject;
    constructor() {
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }

    public waitForPromise(): Promise<T> {
        return this._promise;
    }

    public resolve(data?: T): Promise<T> {
        this._resolve(data);
        return this._promise;
    }

    public reject(err?: any): Promise<T> {
        this._reject(err);
        return this._promise;
    }

    public then(callBack?: (response?: T) => void) {
        return this._promise.then((data) => {
            if(callBack) {
                return callBack(data);
            } else {
                return data;
            }
        });
    }

    public catch(callBack?: (error?: any) => void) {
        return this._promise.catch((err) => {
            if(callBack) {
                return callBack(err);
            } else {
                return err;
            }
        });
    }
}